export const links = [
  {
    id: 1,
    path: 'root-app',
    text: 'home',
  },
  {
    id: 2,
    path: 'about',
    text: 'about',
  },
  {
    id: 3,
    path: 'services',
    text: 'services',
  },
  {
    id: 4,
    path: 'projects',
    text: 'projects',
  },
  {
    id: 5,
    path: 'contact',
    text: 'contact',
  },
];
